import { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardMedia,
  IconButton,
  Paper,
  Container,
  Fade,
} from "@mui/material";
import {
  ArrowBackIos,
  ArrowForwardIos,
} from "@mui/icons-material";
import { colors } from "../../constants/colors";

const ImageSlider = ({ slides }: { slides: any[] }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  console.log('slides', slides);
  // const slides = [
  //   {
  //     id: 1,
  //     image:
  //       "https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  //     title: "Modern Architecture",
  //     subtitle: "Stunning geometric designs",
  //     category: "Architecture",
  //     likes: 1247,
  //   },
  //   {
  //     id: 2,
  //     image:
  //       "https://images.unsplash.com/photo-1518837695005-2083093ee35b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  //     title: "Ocean Waves",
  //     subtitle: "Nature's rhythm and beauty",
  //     category: "Nature",
  //     likes: 892,
  //   },
  //   {
  //     id: 3,
  //     image:
  //       "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  //     title: "Mountain Vista",
  //     subtitle: "Breathtaking landscapes",
  //     category: "Landscape",
  //     likes: 2156,
  //   },
  //   {
  //     id: 4,
  //     image:
  //       "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  //     title: "City Lights",
  //     subtitle: "Urban nighttime magic",
  //     category: "Urban",
  //     likes: 1683,
  //   },
  //   {
  //     id: 5,
  //     image:
  //       "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  //     title: "Forest Path",
  //     subtitle: "Journey into the wild",
  //     category: "Nature",
  //     likes: 934,
  //   },
  //   {
  //     id: 6,
  //     image:
  //       "https://images.unsplash.com/photo-1469474968028-56623f02e42e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  //     title: "Desert Sunset",
  //     subtitle: "Golden hour perfection",
  //     category: "Landscape",
  //     likes: 1789,
  //   },
  // ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const toggleAutoplay = () => {
    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    let interval: any = null;

    if (isPlaying) {
      interval = setInterval(nextSlide, 4000);
    }
    return () => clearInterval(interval);
  }, [isPlaying]);

  return (
    <Container maxWidth="lg">
      <Paper
        elevation={0}
        sx={{
          position: "relative",
          borderRadius: 4,
          overflow: "hidden",
          p: 1,
        }}
      >
        {/* Slide Indicators at Top */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
            mb: 3,
          }}
        >
          {slides.map((_, index) => (
            <IconButton
              key={index}
              onClick={() => goToSlide(index)}
              size="small"
              sx={{
                width: 35,
                height: 35,
                borderRadius: "50%",
                backgroundColor:
                  index === currentSlide
                    ? colors.themeMainColor
                    : "transparent",
                border: `2px solid ${
                  index === currentSlide ? colors.themeMainColor : colors.gray
                }`,
                color: index === currentSlide ? "white" : colors.gray,
                fontSize: "8px",
                fontWeight: "bold",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor:
                    index === currentSlide
                      ? colors.themeMainColor
                      : "rgba(33, 150, 243, 0.1)",
                  transform: "scale(1.1)",
                },
              }}
            >
              {index + 1}
            </IconButton>
          ))}
        </Box>

        {/* Main Slider with Navigation */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          {/* Previous Button */}
          <IconButton
            onClick={prevSlide}
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              color: "black",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              "&:hover": {
                backgroundColor: "white",
                transform: "scale(1.1)",
              },
              transition: "all 0.3s ease",
              minWidth: 48,
              minHeight: 48,
            }}
            size="large"
          >
            <ArrowBackIos />
          </IconButton>

          {/* Image Card */}
          <Card
            sx={{
              flex: 1,
              height: { xs: 300, md: 500 },
              borderRadius: 3,
              overflow: "hidden",
              boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
              position: "relative",
            }}
          >
            {slides.map((slide, index) => (
              <Fade
                key={slide.id}
                in={index === currentSlide}
                timeout={600}
                style={{
                  position: index === currentSlide ? "relative" : "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
              >
                <Box
                  sx={{ position: "relative", width: "100%", height: "100%" }}
                >
                  <CardMedia
                    component="img"
                    image={slide.fullUrl}
                    alt={slide.title}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>
              </Fade>
            ))}
          </Card>

          {/* Next Button */}
          <IconButton
            onClick={nextSlide}
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              color: "black",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              "&:hover": {
                backgroundColor: "white",
                transform: "scale(1.1)",
              },
              transition: "all 0.3s ease",
              minWidth: 48,
              minHeight: 48,
            }}
            size="large"
          >
            <ArrowForwardIos />
          </IconButton>
        </Box>
      </Paper>
    </Container>
  );
};

export default ImageSlider;
